import { render, staticRenderFns } from "./TramiteNuevo.vue?vue&type=template&id=fee036a0&"
import script from "./TramiteNuevo.vue?vue&type=script&lang=js&"
export * from "./TramiteNuevo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports